import { useRouter } from 'next/router';

import generateBreadcrumbs from 'molecules/Breadcrumbs/utils/generateBreadcrumbs';
import Icon from 'molecules/Icon';
import Link from 'molecules/Link';

import ScrollFadeSection from 'components/Animations/ScrollFadeSection';

import type { FC } from 'react';

interface BreadcrumbProps {
  breadcrumbTitle?: string;
}

const Deliminator = () => (
  <div className="text-white">
    <Icon icon="chevron-right" size={16} className="shrink-0" />
  </div>
);

const BreadcrumbLink = ({ link, label }: { link: string; label: string }) => (
  <>
    <Link href={link} className="text-nowrap text-sm text-white" enablePreview={false}>
      {label}
    </Link>
    <Deliminator />
  </>
);

const Breadcrumbs: FC<BreadcrumbProps> = ({ breadcrumbTitle }) => {
  const { query, asPath } = useRouter();
  const queryString = new URLSearchParams(query as Record<string, string>).toString();

  const breadcrumbs = generateBreadcrumbs(asPath.split('?')[0], queryString);

  return (
    <div className="flex items-center gap-3 sm:gap-4">
      <ScrollFadeSection className="flex items-center gap-3 sm:gap-4" animateOnMount>
        <Link href="/" className="text-white" aria-label="Home" enablePreview={false}>
          <Icon icon="home" size={20} className="stroke-2" />
        </Link>
        <Deliminator />
        {breadcrumbs.map(({ id, link, label }, index) => {
          const isLast = index === breadcrumbs.length - 1;
          const finalLabel = isLast && breadcrumbTitle ? breadcrumbTitle : label;

          return isLast ? (
            <span key={id} className="truncate text-sm text-white">
              {finalLabel}
            </span>
          ) : (
            <BreadcrumbLink key={id} link={link} label={label} />
          );
        })}
      </ScrollFadeSection>
    </div>
  );
};

export default Breadcrumbs;
